import "./style.css";
import { App } from "./app";

const canvas = document.querySelector<HTMLCanvasElement>("#view");
if (!canvas) throw new Error("Missing #view canvas");

const app = new App(canvas);
app.start();
